module.exports = __webpack_public_path__ + "static/media/default-logo-new.de4ef99c.png";